import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  const handleScrollToCTA = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.getElementById('comprar');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="relative pt-16 pb-20 px-6 md:pt-24 md:pb-32 overflow-hidden" data-id="element-88">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-89">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="order-2 md:order-1" data-id="element-90">
          <span className="inline-block px-3 py-1 mb-6 text-sm font-semibold tracking-wider text-teal-600 uppercase bg-teal-50 rounded-full" data-id="element-91">
            Proteína Lista (sin pensar)
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-warm-900 leading-[1.1] mb-6 font-display" data-id="element-92">
            Hay una versión de ti que compra pechuga de pollo, un brócoli,
            arroz…
          </h1>

          <p className="text-lg md:text-xl text-warm-900/80 mb-8 leading-relaxed" data-id="element-93">
            …y genuinamente cree que "esta semana sí".
          </p>

          <p className="text-lg md:text-xl text-warm-900/80 mb-10 leading-relaxed" data-id="element-94">
            Y hay otra versión de ti —la real, la de lunes a las 8:47pm— que
            abre el refri, ve ingredientes sueltos y siente el vacío mental más
            caro del mundo.
          </p>

          <a href="#comprar" onClick={handleScrollToCTA} className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-300 bg-teal-600 rounded-lg hover:bg-teal-700 hover:scale-[1.02] shadow-lg hover:shadow-xl group w-full md:w-auto" data-id="element-95">
            Quiero mi sistema
            <ArrowRight className="w-5 h-5 ml-2 transition-transform group-hover:translate-x-1" data-id="element-96" />
          </a>
        </motion.div>

        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        rotate: 2
      }} animate={{
        opacity: 1,
        scale: 1,
        rotate: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="order-1 md:order-2 flex justify-center" data-id="element-97">
          <div className="relative" data-id="element-98">
            <div className="absolute inset-0 bg-teal-600/10 rounded-3xl blur-3xl transform rotate-6 scale-90 -z-10" data-id="element-99"></div>
            <img src="https://cdn.magicpatterns.com/uploads/2onAkZtP1ep7peGbjt1F7Y/PROTEINA_LISTA_SIN_PENSAR.png" alt="Proteína Lista (sin pensar) Ebook Cover" className="w-full max-w-[400px] rounded-xl shadow-soft transform hover:-translate-y-2 transition-transform duration-500" data-id="element-100" />
          </div>
        </motion.div>
      </div>
    </section>;
}